import metadataReducer from "./metadataSlice";

export default metadataReducer;
